import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function Sunset({ color = 'black', size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 16 16" width={size} {...props}>
      <Path
        d="M1 10.377H15"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
      <Path
        d="M2.56952 12.6396H13.4301"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
      <Path
        d="M4.31647 9.63275C4.31647 8.64261 4.7098 7.69302 5.40994 6.99288C6.11007 6.29275 7.05966 5.89941 8.0498 5.89941C9.03994 5.89941 9.98953 6.29275 10.6897 6.99288C11.3898 7.69302 11.7831 8.64261 11.7831 9.63275"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
      <Path
        d="M13.076 7.35999L14.2828 6.82532"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
      <Path
        d="M3.0235 7.35999L1.81671 6.82532"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
      <Path
        d="M6.15098 4.56714L5.6163 3.36035"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
      <Path
        d="M10.1078 4.56714L10.6424 3.36035"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
      />
    </Svg>
  );
});
